import { selectTextbook, textbookChoose } from "../store/teacher";

export const ITEM_CODES = {
  round1: "ECS001",
  round2: "ECS002",
};

export function isAvailablePartItemCodes(itemCodes: string[]) {
  const results = itemCodes.map(itemCode =>
    [ITEM_CODES["round1"], ITEM_CODES["round2"]].includes(itemCode),
  );
  return results.includes(true);
}

export function getGuidanceScreenPath(itemCodes: string[]) {
  return isAvailablePartItemCodes(itemCodes) ? selectTextbook : textbookChoose;
}
